/**
 * MWS Portal Services
 * REST Services der Portal-Anwendung MWS
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BookingPositionComplaintPayloadState { 
    type?: BookingPositionComplaintPayloadState.TypeEnum;
}
export namespace BookingPositionComplaintPayloadState {
    export type TypeEnum = 'OPENED' | 'CLOSED';
    export const TypeEnum = {
        Opened: 'OPENED' as TypeEnum,
        Closed: 'CLOSED' as TypeEnum
    };
}


